export default function chat() {
    const chatButton = document.getElementById("chat");
    const chatText = document.querySelector(".chat__text");
    const chatItems = document.querySelectorAll(".chat-item");
    const chatTitle = document.querySelector(".text__title");
    const chatMessage = document.querySelector(".text__message");

    // chatItems.forEach(item => {
    //     item.addEventListener("click", () => {
    //         chatText.style.display = "flex";

    //         e.preventDefault();
    //         chatItems.forEach(i => i.classList.remove("is-active"));

    //         item.classList.add("is-active");
    //         chatTitle.style.opacity = "1";
    //         chatMessage.style.opacity = "1";
    //     });
    // });
}
